import styled from 'styled-components'

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 16px;
  gap: 6px;
`

export const Wrapper = styled.div`
  display: flex;
  @media(max-width: 1024px) {
    flex-direction: column;
  }
`

export const TableWrapper = styled.div`
  width: 60%;
  @media(max-width: 1024px) {
    width: 100%;
  }
`

export const LocationWrapper = styled.div`
  padding: ${({ fullScreen }) => fullScreen ? '16px 0px' : '60px 16px 16px 0px'};
  width: ${({ fullScreen }) => fullScreen ? '100%' : '40%'};
  min-width: 400px;
   
  .leaflet-container {
    height: 520px;
  }
  .leaflet-control-attribution {
    display: none;
  }

  @media(max-width: 1024px) { 
    ${({ fullScreen }) => fullScreen ? '' : 'width: 100%; padding: 8px 0px;'}
  }

  .leaflet-control.leaflet-draw a {
    color: white;
    &:hover {
      color: #7bd9d3;
    }
  }
`

export const BackButton = styled.div`
  padding: 8px 8px 16px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  gap: 10px;
  .anticon {
    font-size: 18px;
    cursor: pointer;
  }
`

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const LocationFormWrapper = styled.div`
  display: flex;
  gap: 12px;

  .ant-form-item {
    margin-bottom: 0px;
  }
`

export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`

export const SubTitle = styled.div`
  font-weight: 600;
  padding-bottom: ${({ section }) => section ? '8px' : '24px'};
  cursor: default;
`

export const UploadWrapper = styled.div`
  display: flex;
  font-size: 14px;

  @media(max-width: 1100px) {
    flex-direction: column;
  }
`

export const ExampleWrapper = styled.div`
  width: 55%;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  th {
    padding: 4px 8px;
    font-weight: 500;
  }
  td {
    padding: 2px 4px;
  }

  @media(max-width: 1100px) {
    width: 100%;
  }
`

export const InfoWrapper = styled.div`
  width: 45%;
  padding: 0px 8px 0px 12px;

  .option-and-btn {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    .ant-upload-wrapper {
      display: flex;
      gap: 12px;
      .ant-upload-list, .ant-upload-list .ant-upload-list-item-container {
        display: flex;
      }
      .ant-upload-list .ant-upload-list-item {
        margin: auto 0px;
      }
    }
  }

  @media(max-width: 1100px) {
    width: 100%;
    padding: 16px 0px 0px;
  }
`

export const Description = styled.div`
  margin: 16px 0px 0px;
  padding: 16px;
  background: #ddf1f0;
  border: 1px solid var(--primary);

  .title {
    color: #33908a;
    font-weight: 500;
  }

  ul {
    margin-top: 14px;
    padding-left: 18px;
    line-height: 22px;
  }
`

export const EmptyUpload = styled.div`
  margin-top: 16px;
  padding: 16px;
  text-align: center;
  background: rgba(0,0,0,.04);
  border: 1px solid rgba(0,0,0,.1);
  font-size: 14px;
`

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  vertical-align: middle;
  padding: 24px 0px 8px;
`
